import React from 'react';
import styled from '@emotion/styled';
import { AccessCodeRecordInterface } from '../../../../types/accessCode';

interface EmailColumnProps {
  record: AccessCodeRecordInterface;
}

export default React.memo((props: EmailColumnProps) => {
  return (
    <StyledContainer>
      {props.record.fullName && <span>{props.record.fullName}</span>}
      {!props.record.fullName && <span className="tbd">TBD</span>}
    </StyledContainer>
  );
});

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  span {
    font-weight: 600;
  }
`;
